import { render, staticRenderFns } from "./OfficePropertiesSold.vue?vue&type=template&id=c61a0ee4&scoped=true&"
import script from "./OfficePropertiesSold.vue?vue&type=script&lang=ts&"
export * from "./OfficePropertiesSold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61a0ee4",
  null
  
)

export default component.exports